import React from "react"
import FieldProto_FormElement from "../../../proto/render/form-element";
import EditableInput from "../../string/render/inline-editable/input-component";

export default class FieldPassword_FormElement extends FieldProto_FormElement {

    render() {

        const classes: string = Classes("ui5-field-form-editable h-36 p-l-10 p-r-10", this.props.className)

        return <EditableInput className={classes}
                              inputClassName="ui5-txt-default"
                              type    = "password"
                              // field                = {this.props.field}
                              value                = {this.value}
                              disabled             = {this.props.disabled}
                              onImmediateChange    = {this.onChange}
        />
    }

}